export default {
  header: 'Ops, si è verificato qualcosa di inaspettato',
  text: 'Riavvia la pagina o clicca sul pulsante «Torna al menu» qui sotto.',
  button: 'Torna al menu',
};
